// Credit update event name
export const CREDIT_UPDATE_EVENT = 'creditUpdate';

// Function to trigger credit update event
export const triggerCreditUpdate = () => {
  // Dispatch a custom event that components can listen to
  window.dispatchEvent(new Event(CREDIT_UPDATE_EVENT));
}; 